<template>
  <next-steps-base-card title="לפתוח חיסכון דינאמי דרך  רייזאפ"
                        button-text="לחיסכון לטווח ארוך"
                        description="5 דקות, פתיחת קופת גמל"
                        :action-key="actionKey"
                        :disabled="hasFunds"
                        @click="goToLongTermSaving"/>
</template>

<script>
import { mapGetters } from 'vuex';
import NextStepsBaseCard from '../NextStepsBaseCard';
import { ActionKeys } from '../my-progress-next-steps.consts';

export default {
  name: 'LongTermSavingNextStep',
  components: {
    NextStepsBaseCard,
  },
  data() {
    return {
      actionKey: ActionKeys.LONG_TERM_SAVING,
    };
  },
  computed: {
    ...mapGetters('savingZone', ['hasFunds']),
  },
  methods: {
    goToLongTermSaving() {
      this.$router.push({ path: '/saving-zone' });
    },
  },
};
</script>

<style scoped>

</style>
